import ActionButton from 'shared/components/molecules/ActionButton/ActionButton';

export default ActionButton;
